(function(){
  var root = document.getElementById('pi-book');
  if(!root) return;

  /* Зона обслуживания: набережная Гудзона, с севера на юг. 'ZIP':'Город|Округ'
     Список намеренно узкий — это линия по берегу, а не пять округов.
     Чужой индекс форму НЕ блокирует: показывается «не на маршруте сегодня»,
     заявка уходит, дальше договариваемся о точке встречи. */
  var ZONE = {
    '07620':'Alpine|Bergen',            '07670':'Tenafly|Bergen',            '07632':'Englewood Cliffs|Bergen',
    '07024':'Fort Lee|Bergen',          '07020':'Edgewater|Bergen',
    '07010':'Cliffside Park|Bergen',  // 07047 North Bergen убран из маршрута 02.10.2026
    '07093':'West New York and Guttenberg|Hudson',
    '07086':'Weehawken|Hudson',         '07030':'Hoboken|Hudson',
    '07302':'Jersey City|Hudson',       '07304':'Jersey City|Hudson',
    '07305':'Jersey City|Hudson',       '07306':'Jersey City|Hudson',
    '07307':'Jersey City|Hudson',       '07310':'Jersey City|Hudson',
    '07311':'Jersey City|Hudson'
  };

  var steps = root.querySelectorAll('.bk-step');
  var tabs  = root.querySelectorAll('.bk-prog__i');
  var bar   = root.querySelector('.bk-prog__bar i');
  if(!steps.length) return;
  var cur = 1, max = steps.length, seen = 1;

  function show(n, scroll){
    cur = n; seen = Math.max(seen, n);
    steps.forEach(function(s){ s.classList.toggle('is-on', +s.dataset.step === n); });
    tabs.forEach(function(t,i){
      t.classList.toggle('is-on', i+1 === n);
      t.classList.toggle('is-done', i+1 < n);
    });
    if(bar) bar.style.width = (n / max * 100) + '%';
    if(scroll){
      var y = root.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({top:y, behavior:'smooth'});
    }
  }

  function validate(n){
    var step = steps[n-1], ok = true;
    step.querySelectorAll('[required],[data-req]').forEach(function(el){
      var wrap = el.closest('.bk-f');
      if(wrap && wrap.hidden){ wrap.classList.remove('is-bad'); return; }
      var bad;
      if(el.type === 'checkbox') bad = !el.checked;
      else bad = !el.value || (el.type === 'email' && !/^\S+@\S+\.\S+$/.test(el.value));
      if(wrap) wrap.classList.toggle('is-bad', bad);
      if(bad && ok){ ok = false; try{ el.focus(); }catch(e){} }
    });
    var groups = step.querySelectorAll('[data-req-group]');
    for(var g = 0; g < groups.length; g++){
      var grp = groups[g];
      var any = grp.querySelectorAll('input:checked').length > 0;
      (grp.closest('.bk-f') || grp).classList.toggle('is-bad', !any);
      if(!any){
        ok = false;
        try{ grp.scrollIntoView({block:'center', behavior:'smooth'}); }catch(e){}
      }
    }
    return ok;
  }

  root.querySelectorAll('[data-next]').forEach(function(b){
    b.addEventListener('click', function(){ if(validate(cur)) show(Math.min(cur+1,max), true); });
  });
  root.querySelectorAll('[data-prev]').forEach(function(b){
    b.addEventListener('click', function(){ show(Math.max(cur-1,1), true); });
  });
  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      var n = +t.dataset.goto;
      if(n <= seen) show(n, true);
      else if(validate(cur)) show(Math.min(cur+1,max), true);
    });
  });

  /* зависимые поля */
  root.querySelectorAll('[data-reveal]').forEach(function(el){
    var tgt = root.querySelector(el.getAttribute('data-reveal'));
    if(!tgt) return;
    var inner = tgt.querySelector('input,select,textarea');
    function sync(){
      var on = el.value === el.getAttribute('data-when');
      tgt.hidden = !on;
      if(inner){
        if(on) inner.setAttribute('data-req','');
        else { inner.removeAttribute('data-req'); inner.value = ''; }
      }
      if(!on) tgt.classList.remove('is-bad');
    }
    el.addEventListener('change', sync);
    sync();
  });

  /* вес → ценовая полоса */
  var w = root.querySelector('#bk-weight'), wn = root.querySelector('#bk-weight-note');
  if(w && wn){
    w.addEventListener('input', function(){
      var n = parseInt(w.value, 10);
      if(!n){ wn.textContent = 'Weight sets the price. Nothing else changes.'; return; }
      var band = n < 25 ? 'small' : (n <= 60 ? 'medium' : 'large');
      wn.textContent = 'That puts her in the ' + band + ' band. It changes the price and nothing else.';
    });
  }

  /* ZIP → город и округ */
  var zip  = root.querySelector('#bk-zip'),
      note = root.querySelector('#bk-zip-note'),
      tHid = root.querySelector('#bk-town'),
      cHid = root.querySelector('#bk-county'),
      tWrap= root.querySelector('#bk-town-wrap'),
      tMan = root.querySelector('#bk-town-manual');

  if(tMan && tHid) tMan.addEventListener('input', function(){ tHid.value = tMan.value; });

  if(zip && note){
    zip.addEventListener('input', function(){
      var v = zip.value.replace(/\D/g,'').slice(0,5);
      zip.value = v;
      note.className = 'bk-f__note';
      if(v.length < 5){
        note.textContent = ''; tWrap.hidden = true;
        tMan.removeAttribute('data-req'); tHid.value = ''; cHid.value = '';
        return;
      }
      var hit = ZONE[v];
      if(hit){
        var p = hit.split('|');
        tHid.value = p[0]; cHid.value = p[1] + ' County';
        tWrap.hidden = true; tMan.removeAttribute('data-req');
        note.textContent = p[0] + ', ' + p[1] + ' County. The van comes to your door.';
        note.classList.add('is-good');
      } else {
        tHid.value = ''; cHid.value = 'Outside the waterfront route';
        tWrap.hidden = false; tMan.setAttribute('data-req','');
        note.textContent = 'Not on a van route today. Finish the form anyway — we will add you to the waitlist, and routes grow where enough dogs ask.';
        note.classList.add('is-warn');
      }
    });
  }

  /* ────────────────────────────────────
     Отправка. Товар кладём в корзину через /cart/add.js и только после
     подтверждённого ответа уводим в чекаут. Письмо на почту магазина
     уходит следом, а не заранее: POST /contact поднимает у Shopify флаг
     «форма отправлена», и если корзина падала, этот флаг рисовал на
     странице зелёную плашку «It is with us.» вместо ошибки.
     ──────────────────────────────────── */
  var FORM_ID = 'pi-book-form';
  var sent = false, leaving = false;

  function theForm(){
    return document.getElementById(FORM_ID) || root.querySelector('form');
  }

  var form0 = theForm();
  if(form0) form0.setAttribute('novalidate', 'novalidate');

  function banner(text, href){
    var box = root.querySelector('#bk-live-err');
    if(!box){
      box = document.createElement('div');
      box.id = 'bk-live-err';
      box.className = 'bk-err';
      var host = root.querySelector('.bk-form');
      if(host) host.insertBefore(box, host.firstChild);
    }
    box.textContent = text;
    if(href){
      box.appendChild(document.createTextNode(' '));
      var a = document.createElement('a');
      a.href = href; a.textContent = 'Open checkout';
      a.style.color = 'inherit'; a.style.fontWeight = '700';
      box.appendChild(a);
    }
    try{ box.scrollIntoView({block:'center', behavior:'smooth'}); }catch(e){}
  }

  function email(){
    var el = root.querySelector('input[name="contact[email]"]');
    return el ? el.value.trim() : '';
  }

  function fields(){
    var out = {}, f = theForm();
    if(!f) return out;
    new FormData(f).forEach(function(v, k){
      if(!v || k === 'form_type' || k === 'utf8' || k === 'contact[Summary]') return;
      var name = k.replace(/^contact\[/, '').replace(/\]$/, '');
      if(name === 'body') name = 'Notes';
      v = String(v).slice(0, 255);
      out[name] = out[name] ? (out[name] + ', ' + v).slice(0, 255) : v;
    });
    return out;
  }

  /* ─────────────────────────────────────────────────────────────
     КАЛЕНДАРЬ ВЫЕЗДОВ

     Своими силами, без приложения. Приложение BookX умело считать занятость,
     но пускало выбрать только одну дату за раз — а нам нужен набор под пакет:
     одна дата на пробный день, семь, четырнадцать или тридцать на пакеты,
     причём вразбивку, не подряд.

     Чего здесь принципиально нет: занятости. Витрина Shopify не может писать
     в общее хранилище, поэтому два клиента способны выбрать один и тот же
     день. Накладки разбираются письмом — при нынешнем обороте это дешевле,
     чем подстраивать услугу под чужой календарь.

     Норма дат берётся из data-trips выбранного пакета. Срок, окно и закрытые
     дни задаются в редакторе тем, настройками секции.

     Даты уезжают в заказ помесячно — «Dates — Aug 2026: 14, 17, 21». Одной
     строкой нельзя: значения свойств режутся на 255 символах, тридцать дат
     туда не влезают. Помесячно и короче, и читается лучше. */
  function calendar(){
    var wrap = document.getElementById('bk-cal-wrap');
    var cal  = wrap && wrap.querySelector('.bk-cal');
    if(!cal) return;

    var grid  = cal.querySelector('[data-cal-grid]');
    var title = cal.querySelector('[data-cal-title]');
    var count = wrap.querySelector('[data-cal-count]');
    var list  = wrap.querySelector('[data-cal-picked]');
    var note  = wrap.querySelector('[data-cal-note]');
    var sum   = document.getElementById('bk-cal-sum');
    var out   = document.getElementById('bk-cal-out');
    var flex  = document.getElementById('bk-flex');

    var LEAD   = parseInt(cal.getAttribute('data-lead-days'), 10);
    var MONTHS = parseInt(cal.getAttribute('data-window-months'), 10);
    if(!(LEAD >= 0)) LEAD = 2;
    if(!(MONTHS >= 1)) MONTHS = 3;
    var BLACK = {};
    (cal.getAttribute('data-blackout') || '').split(/[\s,;]+/).forEach(function(d){
      if(/^\d{4}-\d{2}-\d{2}$/.test(d)) BLACK[d] = 1;
    });

    var MON = ['January','February','March','April','May','June',
               'July','August','September','October','November','December'];
    var SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    function key(d){
      var m = d.getMonth() + 1, day = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
    }
    function midnight(d){ return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }

    var today = midnight(new Date());
    var min = new Date(today); min.setDate(min.getDate() + LEAD);
    var max = new Date(today.getFullYear(), today.getMonth() + MONTHS + 1, 0); /* конец последнего месяца окна */
    var view = new Date(min.getFullYear(), min.getMonth(), 1);
    var picked = [];

    function need(){
      var r = document.querySelector('input[name="contact[Plan]"]:checked');
      var n = r ? parseInt(r.getAttribute('data-trips'), 10) : 0;
      return n > 0 ? n : 0;
    }

    function render(){
      var n = need();
      title.textContent = MON[view.getMonth()] + ' ' + view.getFullYear();
      cal.querySelector('[data-cal-prev]').disabled =
        (view.getFullYear() === min.getFullYear() && view.getMonth() === min.getMonth());
      cal.querySelector('[data-cal-next]').disabled =
        (view.getFullYear() === max.getFullYear() && view.getMonth() === max.getMonth());

      var first = new Date(view.getFullYear(), view.getMonth(), 1);
      var last  = new Date(view.getFullYear(), view.getMonth() + 1, 0);
      var html = '';
      for(var pad = 0; pad < first.getDay(); pad++) html += '<span class="bk-cal__pad"></span>';
      for(var day = 1; day <= last.getDate(); day++){
        var d = new Date(view.getFullYear(), view.getMonth(), day), k = key(d);
        var off = d < min || d > max || BLACK[k];
        var on  = picked.indexOf(k) > -1;
        var full = !on && n && picked.length >= n;
        html += '<button type="button" class="bk-cal__d' + (on ? ' is-on' : '') + '"' +
                (off || full ? ' disabled' : '') + ' data-d="' + k + '">' + day + '</button>';
      }
      grid.innerHTML = html;
      paint();
    }

    function paint(){
      var n = need();
      picked.sort();
      count.textContent = n
        ? picked.length + ' of ' + n + (n === 1 ? ' day chosen' : ' days chosen')
        : '';
      list.innerHTML = picked.map(function(k){
        var p = k.split('-');
        return '<button type="button" class="bk-cal__chip" data-drop="' + k + '">' +
               SHORT[+p[1] - 1] + ' ' + (+p[2]) + '<i>&#215;</i></button>';
      }).join('');

      /* помесячно — иначе тридцать дат не влезут в 255 символов свойства */
      var by = {}, order = [];
      picked.forEach(function(k){
        var p = k.split('-'), label = SHORT[+p[1] - 1] + ' ' + p[0];
        if(!by[label]){ by[label] = []; order.push(label); }
        by[label].push(String(+p[2]));
      });
      out.innerHTML = order.map(function(label){
        return '<input type="hidden" name="contact[Dates — ' + label + ']" value="' + by[label].join(', ') + '">';
      }).join('');

      var ok = n ? (flex && flex.checked ? picked.length >= 1 : picked.length === n) : false;
      sum.value = ok
        ? picked.length + ' of ' + n + ' dates chosen' + (flex && flex.checked ? ', flexible on the rest' : '')
        : '';
      if(!n) note.textContent = 'Choose a plan first — the number of days comes from it.';
      else if(flex && flex.checked) note.textContent = 'Pick the days you already know. We will agree the remaining ' + Math.max(0, n - picked.length) + ' with you.';
      else if(picked.length < n) note.textContent = 'Pick ' + (n - picked.length) + ' more, or tick the box below if you cannot pin them all down yet.';
      else note.textContent = 'All set. Earliest booking is ' + LEAD + ' days out; the calendar is open ' + MONTHS + ' months ahead.';
    }

    grid.addEventListener('click', function(e){
      var b = e.target.closest('[data-d]');
      if(!b || b.disabled) return;
      var k = b.getAttribute('data-d'), i = picked.indexOf(k);
      if(i > -1) picked.splice(i, 1); else picked.push(k);
      render();
    });
    list.addEventListener('click', function(e){
      var b = e.target.closest('[data-drop]');
      if(!b) return;
      var i = picked.indexOf(b.getAttribute('data-drop'));
      if(i > -1) picked.splice(i, 1);
      render();
    });
    cal.querySelector('[data-cal-prev]').addEventListener('click', function(){
      view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render();
    });
    cal.querySelector('[data-cal-next]').addEventListener('click', function(){
      view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render();
    });
    /* будни спрашиваем только у тех, кто отметил Flexible: при точных датах
       вопрос «какие дни недели подошли бы» уже не нужен */
    var days = document.getElementById('bk-days');
    function syncDays(){ if(days) days.hidden = !(flex && flex.checked); }
    if(flex) flex.addEventListener('change', function(){ syncDays(); paint(); });
    syncDays();

    /* норма зависит от пакета: сменил пакет — лишние даты снимаем */
    root.querySelectorAll('input[name="contact[Plan]"]').forEach(function(r){
      r.addEventListener('change', function(){
        var first = wrap.hidden;
        wrap.hidden = false;
        var n = need();
        if(n && picked.length > n) picked = picked.slice(0, n);
        render();

        /* Подводим экран к календарю. На телефоне карточки тарифов занимают
           весь экран, календарь оказывается за его краем, и человек не видит,
           что дальше нужно выбрать даты. На десктопе то же самое, только
           мягче. Прокручиваем и при первом появлении, и при смене тарифа:
           норма дат поменялась, и на это стоит посмотреть. */
        try{
          var y = wrap.getBoundingClientRect().top + window.scrollY - 20;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }catch(e){ if(first) wrap.scrollIntoView(); }
      });
    });

    render();
  }

  /* Сводка для письма в магазин. Раньше в тело уходила одна строка, а ответы
     Shopify раскладывал сам — плоским списком, в котором заявку приходилось
     выискивать глазами. Теперь тело письма собирается здесь, по разделам.

     Каждый пункт начинается с «•» и переносится строкой. Если шаблон письма
     сохранит переносы — получится таблица; если схлопнет пробелы, как это
     бывает в HTML-письмах, — останется читаемый список через «•». Формат
     намеренно выживает в обоих случаях. */
  var GROUPS = [
    ['CLIENT',  ['name','email','phone','ZIP','Town','County','Source']],
    ['DOG',     ['Dog name','Breed','Age','Weight lbs','Sex','Energy','With other dogs',
                 'Recall','Bite history','Bite detail','Behaviour','Behaviour detail']],
    ['HEALTH',  ['Vaccinations','Health','Medication']],
    ['BOOKING', ['Plan','Notes']],
    ['CONSENT', ['Owner declaration','Contact consent']]
  ];

  function label(k){ return k.charAt(0).toUpperCase() + k.slice(1); }

  /* Одна строка, по которой заявку видно сразу: пакет, собака, откуда,
     сколько дат. Всё остальное идёт ниже отдельными полями. */
  function headline(prefix){
    var v = fields(), bits = [];
    if(v['Plan']) bits.push(v['Plan']);
    if(v['Dog name']) bits.push(v['Dog name'] + (v['Breed'] ? ', ' + v['Breed'] : ''));
    if(v['Town']) bits.push(v['Town'] + (v['ZIP'] ? ' ' + v['ZIP'] : ''));
    if(v['County'] === 'Outside the waterfront route') bits.push('ВНЕ ЗОНЫ ОБСЛУЖИВАНИЯ');
    var dates = [];
    for(var k in v){ if(k.indexOf('Dates — ') === 0) dates.push(k.replace('Dates — ', '') + ': ' + v[k]); }
    if(dates.length) bits.push(dates.join(' · '));
    if(v['Dates flexible']) bits.push('flexible on the rest');
    return prefix + (bits.length ? ' — ' + bits.join(' · ') : '');
  }

  function digest(prefix){
    var v = fields(), used = {}, out = [prefix, ''];
    /* ключи дат создаются на лету — «Dates — Aug 2026», — поэтому в список
       раздела BOOKING их добавляем здесь, иначе уехали бы в «OTHER» */
    for(var dk in v){
      if(dk.indexOf('Dates') === 0 && GROUPS[3][1].indexOf(dk) < 0) GROUPS[3][1].push(dk);
    }
    for(var g = 0; g < GROUPS.length; g++){
      var title = GROUPS[g][0], keys = GROUPS[g][1], lines = [];
      for(var i = 0; i < keys.length; i++){
        var k = keys[i];
        if(v[k]){ lines.push('• ' + label(k) + ': ' + v[k]); used[k] = 1; }
      }
      if(lines.length){ out.push('— ' + title + ' —', lines.join('\n'), ''); }
    }
    var rest = [];
    for(var k2 in v){ if(!used[k2] && v[k2]) rest.push('• ' + label(k2) + ': ' + v[k2]); }
    if(rest.length){ out.push('— OTHER —', rest.join('\n')); }
    return out.join('\n');
  }

  /* письмо на почту магазина — не блокирует переход */
  function post(prefix){
    try{
      var f = theForm();
      if(!f) return false;
      var fd = new FormData(f);
      fd.set('form_type', 'contact');
      fd.set('utf8', '✓');
      /* Шапка письма — короткая. Длинную сводку Shopify показывал пустым
         полем: похоже, режет длинные значения нестандартных полей. Подробности
         и так идут отдельными полями и отображаются исправно, поэтому здесь
         только то, по чему заявку узнают с одного взгляда. */
      fd.set('contact[Summary]', headline(prefix));
      /* пустые поля из письма выбрасываем: незаполненные «Bite detail»,
         «Second dog» и прочие иначе печатаются пустыми строками и топят
         в себе то, что действительно заполнено */
      var drop = [];
      fd.forEach(function(v, k){
        if(k !== 'form_type' && k !== 'utf8' && !String(v).trim()) drop.push(k);
      });
      for(var i = 0; i < drop.length; i++) fd.delete(drop[i]);
      if(navigator.sendBeacon && navigator.sendBeacon('/contact', fd)) return true;
      fetch('/contact', { method:'POST', body: fd, credentials:'same-origin', keepalive:true })
        .catch(function(){});
      return true;
    }catch(e){ return false; }
  }

  try{ calendar(); }catch(e){}

  /* незавершённая заявка */
  function partial(){
    if(sent || leaving) return;
    if(!/^\S+@\S+\.\S+$/.test(email())) return;
    sent = true;
    post('UNFINISHED REQUEST · left on step ' + cur + ' of ' + max);
  }
  document.addEventListener('visibilitychange', function(){
    if(document.visibilityState === 'hidden') partial();
  });
  window.addEventListener('pagehide', partial);

  /* Пробный день — один на человека.
     Настоящий запрет живёт на стороне магазина: Shopify Flow видит историю
     заказов и отменяет дубликат. Здесь заслон от невнимательности — помним
     в браузере, что с этого адреса пробный день уже брали, и второй раз
     не пускаем. Обходится другим браузером, и это осознанно: задача не
     запретить технически, а объяснить человеку, что повтор бесплатным
     не будет, до того как он заполнит форму заново. */
  var TRIAL_VARIANT = '51009773797623';
  var TRIAL_KEY = 'pi-trial-used';

  function mailNow(){
    var el = root.querySelector('input[name="contact[email]"]');
    return el ? el.value.trim().toLowerCase() : '';
  }
  function trialList(){
    try{ var v = JSON.parse(localStorage.getItem(TRIAL_KEY) || '[]'); return v.length ? v : []; }
    catch(e){ return []; }
  }
  function trialSeen(mail){
    return !!mail && trialList().indexOf(mail) !== -1;
  }
  function trialRemember(mail){
    if(!mail) return;
    try{
      var v = trialList();
      if(v.indexOf(mail) === -1){ v.push(mail); localStorage.setItem(TRIAL_KEY, JSON.stringify(v)); }
    }catch(e){}
  }

  /* кладём товар в корзину и ждём ответ: без подтверждения в чекаут не уходим */
  function addToCart(items){
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      return r.text().then(function(t){
        var j = null;
        try{ j = JSON.parse(t); }catch(e){}
        if(r.ok) return j;
        var msg = (j && (j.description || j.message)) || ('Shopify replied ' + r.status);
        throw new Error(msg);
      });
    });
  }

  /* ОТПРАВКА ЗАЯВКИ.

     Раньше всё висело на событии submit. Этого мало: на странице работает
     защита Shopify от спама (hcaptcha/recaptcha), и её скрипт отправляет
     форму вызовом form.submit(). Такой вызов НЕ порождает событие submit —
     наш перехватчик молчал, форма уходила на /contact мимо корзины, человек
     видел зелёную плашку «It is with us.», а заказа не возникало и до оплаты
     дело не доходило.

     Поэтому кнопка больше не type="submit": она обычная, и вся работа идёт
     по её клику. Событие submit слушаем по-прежнему — на случай Enter
     в текстовом поле, — но нативной отправки формы теперь не бывает вовсе. */
  function go(){
    try{
      for(var i = 1; i <= max; i++){
        if(!validate(i)){
          show(i, true);
          banner('Something is missing on step ' + i + ' of ' + max + '. The fields we need are marked in red.');
          return;
        }
      }

      var picked = root.querySelector('input[name="contact[Plan]"]:checked');
      if(!picked){
        show(3, true);
        banner('Please choose a plan on step 3.');
        return;
      }
      var variant = picked.getAttribute('data-variant');
      var plan = picked.value;
      if(!variant){
        banner('That plan is not linked to a product yet. Write to us at info@pawsimperial.com and we will book it by hand.');
        return;
      }

      if(variant === TRIAL_VARIANT && trialSeen(mailNow())){
        show(3, true);
        banner('The Free Trial Day is once per dog, and this email has already used it. Pick 7, 14 or 30 trips on this step \u2014 or write to us at info@pawsimperial.com if you think this is a mistake.');
        return;
      }

      var btn = root.querySelector('.bk-btn--go');
      if(btn){
        btn.disabled = true;
        var sp = btn.querySelector('span');
        if(sp) sp.textContent = 'Taking you to checkout…';
      }

      sent = true; leaving = true;

      var unlock = function(){
        leaving = false;
        if(btn){
          btn.disabled = false;
          var s2 = btn.querySelector('span');
          if(s2) s2.textContent = 'Continue to payment';
        }
      };

      /* тариф первой позицией, отмеченная еда следом — одним заказом.
         Ответы анкеты вешаем только на тариф: дублировать их на каждую
         банку корма незачем, в заказе они и так будут видны. */
      var items = [{ id: Number(variant), quantity: 1, properties: fields() }];
      root.querySelectorAll('input[name="contact[Food]"]:checked').forEach(function(el){
        var fv = el.getAttribute('data-variant');
        if(fv) items.push({ id: Number(fv), quantity: 1 });
      });

      addToCart(items).then(function(){
        /* На /contact больше не пишем. Shopify отдаёт 403 и на fetch,
           и на обычную отправку браузером — канал ненадёжен, а письмо
           «ушло» создавало ложное спокойствие. Заявка целиком уезжает
           в заказ свойствами позиции, и о ней сообщает штатное письмо
           Shopify «Order placed» — оно доходит всегда. Чтобы в нём были
           видны ответы, в шаблон уведомления вставляется код из
           docs/order-confirmation-snippet.md. */
        if(variant === TRIAL_VARIANT) trialRemember(mailNow());
        try{ if(typeof gtag === 'function') gtag('event', 'generate_lead', { plan: plan }); }catch(e){}
        window.location.assign('/checkout');
        setTimeout(function(){
          unlock();
          banner('Checkout did not open on its own.', '/checkout');
        }, 6000);
      }).catch(function(err){
        /* заявку не теряем: письмо уходит с пометкой, что оплата не открылась */
        post('BOOKING REQUEST · CHECKOUT DID NOT OPEN, cart error: ' +
             (err && err.message ? err.message : err));
        unlock();
        banner('We have your request, but the cart would not take the plan: ' +
               (err && err.message ? err.message : err) +
               '. Write to us at info@pawsimperial.com and we will book it by hand.');
      });
    }catch(err){
      banner('Something went wrong while sending: ' + (err && err.message ? err.message : err) +
             '. Write to us at info@pawsimperial.com');
      leaving = false;
      var b2 = root.querySelector('.bk-btn--go');
      if(b2){ b2.disabled = false; }
    }
  }

  var goBtn = root.querySelector('.bk-btn--go');
  if(goBtn) goBtn.addEventListener('click', function(e){ e.preventDefault(); go(); });

  /* Enter в текстовом поле всё ещё способен отправить форму — перехватываем
     в фазе перехвата, чтобы успеть раньше чужих скриптов */
  document.addEventListener('submit', function(e){
    var f = e.target;
    if(!f || (f.id !== FORM_ID && f !== root.querySelector('form'))) return;
    e.preventDefault();
    go();
  }, true);

  /* после успешной отправки Shopify возвращает с ?contact_posted=true */
  if(/contact_posted=true/.test(window.location.search)){
    var prog = root.querySelector('.bk-prog');
    if(prog) prog.style.display = 'none';
    steps.forEach(function(s){ s.classList.remove('is-on'); s.style.display = 'none'; });
  }
})();

/* Миниатюры еды: нажали на фото — открываем крупно, галочку не трогаем. */
(function(){
  var dlg;
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.bk-food__t'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    if(!dlg){
      dlg=document.createElement('dialog'); dlg.className='bk-zoom';
      dlg.innerHTML='<img alt=""><button type="button" class="bk-zoom__x" aria-label="Close">×</button>';
      dlg.addEventListener('click',function(){dlg.close()});
      document.body.appendChild(dlg);
    }
    var img=dlg.querySelector('img'); img.src=b.getAttribute('data-full'); img.alt=(b.getAttribute('aria-label')||'').replace('See photo: ','');
    if(dlg.showModal) dlg.showModal(); else window.open(b.getAttribute('data-full'),'_blank');
  },true);
})();
